import { actionTypes } from '@/context/actionTypes';
import { createContext } from '@/context/createContext';
import { commonAction } from '@/types/commonActions';

export type serviceDataType = {
  activeTab: string;
};

export type serviceDispatchType = {
  setActiveTab: Function;
};

const initialState: serviceDataType = {
  activeTab: '',
};
export function serviceReducer(state: serviceDataType, action: commonAction) {
  const { activeTab = initialState.activeTab }: serviceDataType = action.payload;
  switch (action.type) {
    case actionTypes.SET_ACTIVE_TAB: {
      return {
        ...state,
        activeTab: activeTab,
      };
    }
    default:
      throw new Error(`Unsupported type: ${action.type}`);
  }
}

const setActiveTab = (dispatch: any) => (activeTab: string) => {
  dispatch({ type: actionTypes.SET_ACTIVE_TAB, payload: { activeTab: activeTab } });
};

const { Context: ServiceContext, Provider: ServiceProvider } = createContext<
  serviceDataType,
  serviceDispatchType
>(
  serviceReducer,
  {
    setActiveTab,
  },
  initialState,
);

ServiceContext.displayName = 'Service';

export { ServiceContext, ServiceProvider };
